module.exports = __webpack_public_path__ + "img/img_qrcode_none.4aeb2c45.png";